module.exports = __webpack_public_path__ + "static/media/WS2016.4401d6cb.png";